<template>
    <div :class="containerClass">
        <span class="p-rating-icon p-rating-cancel pi pi-ban" :tabindex="focusIndex" v-if="cancel" @click="onCancelClick"></span>
        <span v-tooltip.top="`${tooltip[index] || ''}`" :key="i" v-for="(i, index) in stars" @click="onStarClick($event,i)" :tabindex="focusIndex" @keydown.enter.prevent="onStarClick($event,i)"
              :class="['p-rating-icon ', fillStar(i) ]"></span>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        stars: {
            type: Number,
            default: 5
        },
        cancel: {
            type: Boolean,
            default: true
        },
        tooltip: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        fillStar(index){
            if (index == this.value) {
                return 'pi pi-star-fill'
            }
            return 'pi pi-star'
        },
        onStarClick(event, value) {
            if (!this.readonly && !this.disabled) {
                this.updateModel(event, value);
            }
        },
        onCancelClick() {
            if (!this.readonly && !this.disabled) {
                this.updateModel(event, null);
            }
        },
        updateModel(event, value) {
            this.$emit('input', value);
            this.$emit('change', {
                originalEvent: event,
                value: value
            });
        }
    },
    computed: {
        emptyArray(){
            return []
        },
        containerClass() {
            return [
                'p-rating',
                {
                    'p-readonly': this.readonly,
                    'p-disabled': this.disabled
                }
            ];
        },
        focusIndex() {
            return (this.disabled || this.readonly) ? null : '0';
        }
    }
}
</script>

<style>
.p-rating{
}
.p-rating .p-rating-icon {
    font-size: x-large;

    color: #e3cf04;
    cursor: pointer;
}
.pi-star-fill{
    color: #e3cf04;
    cursor: pointer;
}

.p-rating:not(.p-disabled):not(.p-readonly) .p-rating-icon:hover {

    color: #c29610;
}

.p-rating .p-rating-icon.pi-star {
    color: #57460b;
}

.p-rating .p-rating-icon:focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: 0 0 0 0.1rem #ffe70b;
}
/*.p-rating .p-rating-icon {*/
/*    */
/*}*/

.p-rating.p-rating-readonly .p-rating-icon {
    cursor: default;
}

.p-rating .p-rating-icon:first-child {
    margin-left: 0.5rem !important;
}
</style>